import * as React from 'react';
import "./Navbar.css"

interface Iprops {
    children: React.ReactNode
}

export default function Navbar({children}: Iprops) {
    return (
        <>  
            <header className="container">
                <h3 style={{ paddingLeft: "20px"}}>GREACW</h3>
            </header>
            <div>{children}</div>
        </>
    )
}